export const FolderShareRole = {
  RoleEdit: "ROLE_EDIT",
  RoleView: "ROLE_VIEW",
} as const;

export const FOLDER_NAME_MAX_LENGTH = 255;
export const FOLDER_NAME_DISPLAY_MAX_LENGTH = 100;
export const FOLDER_SELECT_NAME_MAX_LENGTH = 30;
export const DOMAIN_FOLDER_SELECT_MOBILE_NAME_MAX_LENGTH = 30;
export const DOMAIN_FOLDER_SELECT_DESKTOP_NAME_MAX_LENGTH = 60;
export const FOLDER_NOT_UNIQUE_NAME_ERROR_KEY = "folder.not_unique_name_key";

export type FolderShareRole =
  (typeof FolderShareRole)[keyof typeof FolderShareRole];

export const GqlShareFolderStatus = {
  Shared: "SHARED",
  Waiting: "WAITING",
} as const;

export type GqlShareFolderStatus =
  (typeof GqlShareFolderStatus)[keyof typeof GqlShareFolderStatus];
